import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useSelector } from "react-redux"
import { openTicketFetch } from "store/middlewares/tickets.crud"
import { isValid, submit } from "redux-form"
import { useDispatch } from "react-redux"
import { toast } from "react-toastify"
import { toastConfig } from "config"
import { TicketRM } from "models/RM"
import { useLocation } from "react-router-dom"
import { replaceId } from "utils/formatter"
import { queryClient as qc } from "keys"
import { validate, validateIsAuth } from "../Validate"
import { isEmpty } from "lodash"
import constants from './constants'

const useSubmitBtn = (isUser) => {
    const { formname } = constants
    const dispatch = useDispatch()
    const location = useLocation()
    const queryClient = useQueryClient()
    const formValues = useSelector(state => state.form[formname]?.values)
    const isFormValid = useSelector(state => isValid(formname)(state));
    const validateFunc = isUser ? validateIsAuth : validate

    const screenNames = {
        "/home": "דשבורד",
        "/users": "משתמשים",
        "/test-takers": "תלמידים",
        "/perform-assessments": "מבדקים פעילים",
        "/assessments": "דוחות",
        "/assessments/id": "דוח אישי",
        "/matching-learning/id": "למידה מותאמת",
        "/contact-us": "צור קשר",
        "defualt": "אחר"
    }

    const { mutateAsync: openTicket, isPending: sendMessageLoading } = useMutation({
        mutationFn: openTicketFetch,
        onSuccess: () => {
            toast("פנייתכם התקבלה בהצלחה", toastConfig)
            queryClient.invalidateQueries([qc.ticket])
        }
    })

    const postTicket = async () => {
        const errors = validateFunc(formValues)
        if (isEmpty(errors)) {
            const routeName = replaceId(location.pathname, "id")
            const ticket = new TicketRM({ ...formValues, screen_name: screenNames[routeName] })
            const data = await openTicket(ticket)
            return data
        }
        else {
            dispatch(submit(formname))
            toast.error("לא מלאת את הטופס....", toastConfig)
            return false
        }
    }

    const submitBtn = {
        label: "שליחה",
        action: postTicket,
        color: "secondary",
        fullWidth: true,
        loading: sendMessageLoading,
        disabled: sendMessageLoading
    }

    return submitBtn
}

export default useSubmitBtn


